import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllMiljogebyrEttersendelsebreverPdf } from "../../../actions/miljoEttersendelsebrevActions";
import { getMiljogebyrTilBehandling as getMiljogebyrTilBehandlingAction } from "../../../actions/miljogebyrTilBehandlingActions";
import TilBehandling from "./TilBehandling";

export default function TilBehandlingContainer() {
  const dispatch = useDispatch();

  const miljogebyrTilBehandling = useSelector(
    (state) => state.miljogebyrTilBehandling
  );
  const miljogebyrTilBehandlingFilterForm = useSelector(
    (state) => state.forms.miljogebyrTilBehandlingFilterForm
  );

  const page = miljogebyrTilBehandling && miljogebyrTilBehandling.page;
  const count = miljogebyrTilBehandling && miljogebyrTilBehandling.count;
  const miljogebyrTilBehandlingItems =
    miljogebyrTilBehandling && miljogebyrTilBehandling.items;
  const getMiljogebyrTilBehandling = useCallback(
    () => dispatch(getMiljogebyrTilBehandlingAction({}, page, count)),
    [dispatch, page, count]
  );
  const getMiljogebyrEttersendelsebreverPdf = useCallback(
    (ettersendelseId) =>
      dispatch(getAllMiljogebyrEttersendelsebreverPdf(ettersendelseId)),
    [dispatch]
  );

  return (
    <TilBehandling
      page={page}
      count={count}
      miljogebyrTilBehandlingItems={miljogebyrTilBehandlingItems}
      miljogebyrTilBehandlingFilterForm={miljogebyrTilBehandlingFilterForm}
      getMiljogebyrTilBehandling={getMiljogebyrTilBehandling}
      getAllMiljogebyrEttersendelsebreverPdf={
        getMiljogebyrEttersendelsebreverPdf
      }
    />
  );
}
